import { useState, useEffect } from 'react';
import { useAuthContext } from '@hooks/useAuthContext';

export const useBranches = () => {
    const { user } = useAuthContext();

    return user?.branches ?? [];
};